import AdminEntity from "../../components/admin/AdminEntity";

export default function AdminFAQsPage() {
  return (
    <AdminEntity config={{
      eyebrow: "FAQs",
      title: "Frequently asked questions",
      testidPrefix: "admin-faqs",
      singular: "FAQ",
      addLabel: "New FAQ",
      listEndpoint: "/faqs",
      keyField: "id",
      columns: [
        { key: "category", label: "Category" },
        { key: "question", label: "Question", render: (f) => <span className="font-bold" style={{ fontFamily: "'Nunito', sans-serif" }}>{f.question}</span> },
        { key: "order", label: "#" },
      ],
      createEndpoint: "/admin/faqs",
      updateEndpoint: (f) => `/admin/faqs/${f.id}`,
      deleteEndpoint: (f) => `/admin/faqs/${f.id}`,
      fields: [
        { name: "category", label: "Category", required: true, help: "e.g. Pets, Parking, Booking & Rates" },
        { name: "question", label: "Question", required: true },
        { name: "answer", label: "Answer", type: "textarea", rows: 4, required: true },
        { name: "order", label: "Sort order within category", type: "number", defaultValue: 0 },
      ],
    }} />
  );
}
